"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var ButtonGroupItem = {
  styles: function styles(theme) {
    return {
      input: {
        "&:checked + span": {
          background: theme.colors.baseContrast015,
          "&:hover": {
            background: theme.colors.baseContrast015
          }
        }
      },
      button: {
        color: theme.colors.baseContrast085,
        fontWeight: 400,
        borderInlineEnd: "solid 1px ".concat(theme.colors.baseContrast040),
        "&:hover": {
          background: theme.colors.baseContrast010
        }
      },
      small: {
        padding: [theme.spacing.base, theme.spacing.base * 1.5]
      },
      medium: {
        padding: [theme.spacing.base * 1.5, theme.spacing.base * 2]
      },
      large: {
        padding: [theme.spacing.base * 2, theme.spacing.base * 3]
      }
    };
  }
};
var _default = exports.default = ButtonGroupItem;